import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const AvailabilityNotification = ({ show, onDismiss, message }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/availability-windows');
    onDismiss(); // Dismiss the notification when navigating
  };

  if (!show) return null;

  return (
    <Alert 
      variant="warning" 
      className="availability-notification"
      style={{
        position: 'fixed',
        top: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1050,
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        border: 'none',
        borderRadius: '8px'
      }}
    >
      <div className="d-flex align-items-center justify-content-between">
        <div className="flex-grow-1">
          <Alert.Heading className="mb-1" style={{ fontSize: '1rem' }}>
            <i className="fas fa-calendar-times me-2"></i>
            No Availability Windows
          </Alert.Heading>
          <p className="mb-0" style={{ fontSize: '0.9rem' }}>
            {message}
          </p>
        </div>
        <div className="ms-3">
          <Button 
            variant="outline-warning" 
            size="sm"
            onClick={handleClick}
            style={{ 
              borderColor: '#ffc107',
              color: '#856404',
              fontWeight: 'bold'
            }}
          >
            Set Availability
          </Button>
          <Button 
            variant="link" 
            size="sm"
            onClick={onDismiss}
            style={{ 
              color: '#856404',
              textDecoration: 'none',
              padding: '0.25rem 0.5rem'
            }}
          >
            <i className="fas fa-times"></i>
          </Button>
        </div>
      </div>
    </Alert>
  );
};

export default AvailabilityNotification;
